<div
    id="app-navigation"
    [class.expanded]="!isSidebarCollapsed()"
    [attr.aria-expanded]="!isSidebarCollapsed()"
    (wheel)="hideOverlays()">
    @for (navList of appNavigation(); let i = $index; track i) {
        <ng-container>
            <nav [id]="'app-navigation-section-' + i" class="nav-list" aria-label="Main Navigation">
                @for (navItem of navList; track navItem.id) {
                    @if (!navItem.submenu && !navItem.isHidden) {
                        @if (navItem.internalRoute) {
                            <a
                                (mouseenter)="navItemHover(navItem.id, $event)"
                                [pTooltip]="isSidebarCollapsed() ? (navItem.label | translate) : ''"
                                [routerLink]="navItem.url"
                                [routerLinkActive]="['active-link']"
                                [routerLinkActiveOptions]="{ exact: false }"
                                [id]="navItem.id + '-nav-link'"
                                class="nav-link">
                                <ng-container
                                    [ngTemplateOutlet]="navLink"
                                    [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                            </a>
                        }

                        @if (!navItem.internalRoute) {
                            <a
                                (mouseenter)="navItemHover(navItem.id, $event)"
                                [pTooltip]="isSidebarCollapsed() ? (navItem.label | translate) : ''"
                                [href]="navItem.url"
                                [target]="'_blank'"
                                [id]="navItem.id + '-nav-link'"
                                class="nav-link">
                                <ng-container
                                    [ngTemplateOutlet]="navLink"
                                    [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                            </a>
                        }
                    }

                    @if (navItem.submenu && !navItem.isHidden) {
                        <button
                            (click)="navItemClick(navItem)"
                            (mouseenter)="navItemHover(navItem.id, $event)"
                            [id]="navItem.id + '-nav-link'"
                            [class.active-link]="isRichMenuActive(navItem)"
                            class="nav-link">
                            <ng-container
                                [ngTemplateOutlet]="navLink"
                                [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                        </button>
                    }

                    @if (navItem.submenu) {
                        <div
                            [ngClass]="navItem.expanded ? 'submenu-expanded' : 'submenu-collapsed'"
                            [attr.aria-expanded]="navItem.expanded"
                            class="submenu"
                            [id]="navItem.id + '-submenu'"
                            tabindex="-1">
                            @for (submenuItem of navItem.submenu; track submenuItem.id) {
                                @if (submenuItem.internalRoute) {
                                    <a
                                        [routerLink]="submenuItem.disabled ? null : submenuItem.url"
                                        [routerLinkActive]="['active-submenu-link']"
                                        [routerLinkActiveOptions]="{ exact: false }"
                                        [id]="submenuItem.id + '-submenu-nav-link'"
                                        [tabindex]="!navItem.expanded ? '-1' : '0'"
                                        class="submenu-link"
                                        [class.disabled-option]="submenuItem.disabled">
                                        <div
                                            class="btn-icon-dot"
                                            [id]="submenuItem.id + '-submenu-icon'"
                                            aria-hidden="true">
                                            <span>
                                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                            </span>
                                        </div>
                                        <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                                            submenuItem.label | translate
                                        }}</span>
                                    </a>
                                }

                                @if (!submenuItem.internalRoute) {
                                    <a
                                        [href]="[submenuItem.url]"
                                        [target]="'_blank'"
                                        [id]="submenuItem.id + '-submenu-nav-link'"
                                        [tabindex]="!navItem.expanded ? '-1' : '0'"
                                        class="submenu-link"
                                        [class.external-link]="!submenuItem.internalRoute">
                                        <div>
                                            <div
                                                class="btn-icon-dot"
                                                [id]="submenuItem.id + '-submenu-icon'"
                                                aria-hidden="true">
                                                <span>
                                                    <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                                </span>
                                            </div>
                                            <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                                                submenuItem.label | translate
                                            }}</span>
                                        </div>
                                        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
                                    </a>
                                }
                            }
                        </div>
                    }
                }
            </nav>
        </ng-container>
    }

    <div class="extra-space" (mouseenter)="hideOverlays()"></div>
</div>

<ng-template #navLink let-navItem="navItem">
    <div class="btn-icon" [id]="navItem.id + '-icon'" aria-hidden="true">
        <i [class]="navItem.icon"></i>
    </div>
    <span class="nav-label" [id]="navItem.id + '-label'">{{ navItem.label | translate }}</span>

    @if (navItem.submenu) {
        <div class="expand-btn-container" aria-hidden="true">
            <div
                [id]="navItem.id + '-expand-submenu-btn'"
                class="p-button-rounded p-button-text expand-menu-btn p-button-secondary">
                <i class="fa-light" [ngClass]="navItem.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </div>
        </div>
    }
</ng-template>

<p-overlayPanel #ovMyOrders styleClass="overlay" [style]="overlayStyleMyOrders" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" (wheel)="hideOverlays()" class="overlay">
        <div class="overlay-header">
            <p>{{ 'toolbar.myOrders' | translate }}</p>
        </div>
        <div class="overlay-body">
            @for (submenu of myOrdersSubmenu; track submenu.id) {
                @if (!submenu.internalRoute) {
                    <a [href]="submenu.url" [target]="'_blank'" [id]="submenu.id"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'" aria-hidden="true">
                            <span aria-hidden="true">
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </span>
                        </div>
                        {{ submenu.label | translate }}</a
                    >
                }

                @if (submenu.internalRoute) {
                    <a
                        [routerLink]="submenu.disabled ? null : submenu.url"
                        [id]="submenu.id"
                        (click)="hideOverlays()"
                        [class.disabled-option]="submenu.disabled"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'" aria-hidden="true">
                            <span aria-hidden="true">
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </span>
                        </div>
                        <span>
                            {{ submenu.label | translate }}
                        </span>
                    </a>
                }
            }
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovMySupplies styleClass="overlay" [style]="overlayStyleMySupplies" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" (wheel)="hideOverlays()" class="overlay">
        <div class="overlay-header">
            <p>{{ 'toolbar.mySupplies' | translate }}</p>
        </div>
        <div class="overlay-body">
            @for (submenu of mySuppliesSubmenu; track submenu.id) {
                @if (!submenu.internalRoute) {
                    <a [href]="submenu.url" [target]="'_blank'" [id]="submenu.id"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'" aria-hidden="true">
                            <span>
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </span>
                        </div>
                        {{ submenu.label | translate }}</a
                    >
                }

                @if (submenu.internalRoute) {
                    <a [routerLink]="submenu.url" [id]="submenu.id" (click)="hideOverlays()"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'" aria-hidden="true">
                            <span>
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </span>
                        </div>
                        {{ submenu.label | translate }}</a
                    >
                }
            }
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovMyStrains styleClass="overlay" [style]="overlayStyleMyStrains" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" (wheel)="hideOverlays()" class="overlay">
        <div class="overlay-header">
            <p>{{ 'toolbar.myStrains' | translate }}</p>
        </div>
        <div class="overlay-body">
            @for (submenu of myStrainsSubmenu; track submenu.id) {
                @if (!submenu.internalRoute) {
                    <a [href]="submenu.url" [target]="'_blank'" [id]="submenu.id"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'" aria-hidden="true">
                            <span>
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </span>
                        </div>
                        {{ submenu.label | translate }}</a
                    >
                }

                @if (submenu.internalRoute) {
                    <a [routerLink]="submenu.url" [id]="submenu.id" (click)="hideOverlays()"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'" aria-hidden="true">
                            <span>
                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                            </span>
                        </div>
                        {{ submenu.label | translate }}</a
                    >
                }
            }
        </div>
    </div>
</p-overlayPanel>
